import React from "react";
import useScrollAnimation from "../../../hooks/useScrollAnimation";

/**
 * Redesigned testimonial card with entrance animation and hover effects
 * @param {Object} props
 * @param {string} props.name - Person's name
 * @param {string} props.location - Person's location
 * @param {string} props.testimony - Testimonial text
 * @param {string} props.image - Profile image URL
 * @param {number} props.index - Card index for staggered animation
 */
const TestimonialCard = ({ name, location, testimony, image, index = 0 }) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.2 });

  const animationDelay = index * 100;

  return (
    <div
      ref={ref}
      className={`
        relative bg-cloud-50 rounded-2xl p-6 shadow-sm
        border border-cloud-300
        transition-all duration-500 ease-out
        hover:shadow-xl hover:shadow-pine-800/10
        hover:-translate-y-2
        ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}
      `}
      style={{
        transitionDelay: isVisible ? `${animationDelay}ms` : "0ms",
      }}
    >
      
      {/* Header with image and info */}
      <div className="flex items-center gap-4 mb-4">
        <img
          src={image}
          alt={name}
          className="w-14 h-14 rounded-full object-cover ring-2 ring-moss-300"
        />
        <div>
          <h4 className="font-semibold text-pine-800">{name}</h4>
          <p className="text-sm text-earth-500">{location}</p>
        </div>
      </div>

      {/* Testimonial text */}
      <p className="text-earth-600 leading-relaxed text-sm">{testimony}</p>

      {/* Decorative quote mark */}
      <div className="absolute top-4 right-4 text-6xl text-moss-200 font-serif leading-none select-none">
        "
      </div>
    </div>
  );
};

export default TestimonialCard;
